;(function ($) {
  "use strict";

  $(document).ready(function () {
    accessibilityInit();
  });

  function accessibilityInit() {
    // show / hide skip links and access keys when gain focus
    $('#accessibility-links').focusin(function () {
      $(this).closest('section').addClass('active');
    });

    $('#accessibility-links').focusout(function () {
      $(this).closest('section').removeClass('active');
    });
  }
})(jQuery);
